import autoload from "./autoload";
import colorFilter from "./mixins/color_filter";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import InfiniteLoading from "vue-infinite-loading";
import Search from "./components/global/Search.vue";
import { flexible } from "@nic-industries/hooks";

autoload();

function processCreations(response) {
  return response.data.map((creation) => {
    creation = flexible(creation);

    if (creation.featured_image_url) {
      if (creation.featured_image_url.includes("?")) {
        creation.featured_image_url += "&";
      } else {
        creation.featured_image_url += "?";
      }
    }

    return creation;
  });
}

window.app = new Vue({
  el: "#vue-creation",

  mixins: [
    initDom,
    colorFilter,
    auth,
    cart,
  ],

  components: {
    InfiniteLoading,
    Search
  },

  data() {
    return {
      filterCreations: false,
      creations: [],
      queryParams: {},
      infiniteId: +new Date(),
      message: window._PR?.message || "",
      pagination: {},
      selectedTags: [],
      showFooter: window._PR?.showFooter || false,
    };
  },

  methods: {
    /**
     * @function loadCreations
     * @description sets data to be used here in this file from the Search.vue component
    */
    loadCreations(queryParamData, tags) {
      this.selectedTags = tags;
      this.queryParams = queryParamData;
      this.queryParams.page = 1;
      this.queryParams.limit = 20;
      this.resetLoading();
    },

    /**
     * @function renderColorMatches
     * @todo API: Check if all properties are ok or there is any change required
     * @param entityType [one of (hashtag, location, applicator, color_category)
     * @param key [Which property is to be used for an entity for gallery search, like for hashtags labels are to be used]
     * @returns {{data: [], string: (string)}}
     */

    renderCreations($state) {
      const creationUrl = `/api/proxify/domains/prismatic/creation-search`;

      this.queryParams.orderby = "created_at";
      this.queryParams.orderdir = "desc";
      this.queryParams.hide_color_match_only = true;

      axios
        .get(creationUrl, {
          params: this.queryParams
        })
        .then(({ data: response }) => {
          if (!response) {
            $state.complete();
            this.showFooter = true;
            return;
          }

          if (!response.data.length) {
            $state.complete();
            this.showFooter = true;
          }

          if (response.pagination.page === 1) {
            if (!response.data) {
              this.message = "Sorry, No Matching Creations";
              this.showFooter = true;
            } else {
              this.creations = processCreations(response);
            }
          } else {
            const updatedCreations = processCreations(response);

            this.creations.push(...updatedCreations);
          }

          this.queryParams.page = response.pagination.page + 1;

          $state.loaded();

          // toggle front end rendering
          if (!this.filterCreations) {
            this.filterCreations = true;
          }
        })
        .catch((response) => {
          console.log(response);
          $state.complete();
          this.showFooter = true;
        });
    },

    resetLoading() {
      // Turn on front end rendering
      if (!this.filterCreations) {
        this.filterCreations = true;
      }

      this.showFooter = false;
      this.message = "";
      this.creations = [];
      this.queryParams.page = 1;
      this.infiniteId += 1;
    }
  }
});
